import Icons from "@/components/icons";
import AppIcon from "@/components/AppIcon.vue";
import PauseInCircleIcon from '@/components/icons/PauseInCircleIcon.vue';
import Play3dIcon from '@/components/icons/Play3dIcon.vue';
import LoadingElement from '@/components/shared/LoadingElement.vue';
import AppModal from "@/components/AppModal";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
export default {
  name: "PPCSettingsTabs",
  components: {
    ...Icons,
    AppIcon,
    PauseInCircleIcon,
    Play3dIcon,
    LoadingElement,
    AppModal,
    WrapWithPopover
  },
  emits: ["update:modelValue"],
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => [{
        text: "Tab 1",
        activeColor: "red",
        value: "tab1"
      }]
    },
    modelValue: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean
    },
    status: {
      type: [String, null],
      default: "PAUSED"
    },
    ppc_initialized: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    status: {
      handler(newVal, oldVal) {
        if (typeof newVal == "string" && this.ppc_initialized) {
          this.loading = false;
        }
      },
      immediate: true
    },
    ppc_initialized: {
      handler(newval) {
        this.loading = !newval;
      }
    }
  },
  data() {
    return {
      loading: true,
      texts: {
        ENABLED: "Pause budget strategies",
        PAUSED: "Resume budget strategies"
      },
      changeModal: false
    };
  },
  computed: {
    currentTab: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    cssProps() {
      return {
        "--active-bg": this.disabled ? this.tabs[this.currentTab].disabledActiveBg : this.tabs[this.currentTab].activeBg,
        "--active-color": this.disabled ? this.tabs[this.currentTab].disabledActiveColor : this.tabs[this.currentTab].activeColor,
        "--active-border-color": this.tabs[this.currentTab].activeBorderColor
      };
    },
    enabled() {
      return this.status === 'ENABLED';
    }
  },
  methods: {
    handleClick() {
      this.changeModal = true;
    }
  }
};